import React, { FC } from "react";

export interface JobDetailErrorProps {
  error: string;
  labels: Record<string, string | null>;
}

export const JobDetailError: FC<JobDetailErrorProps> = ({ labels, error }) => {
  return (
    <div className="px-10 py-16 bg-neutral flex flex-col gap-14">
      <h2 className="text-4xl text-primary">{labels["job-detail-fetch-error"]}</h2>
      <p className="text-lg">{error}</p>
    </div>
  );
};
